import axios from "../axios";
const END_POINT = "/countries";


const addCountry = (countries) => axios.post(`${END_POINT}`, countries);
const getAllCountries = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getCountry = (countryId) => axios.get(`${END_POINT}/${countryId}`);
const updateCountry = (countryId, payload) => axios.patch(`${END_POINT}/${countryId}`, payload);
const searchCountry = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteCountry = (countriesId) => axios.delete(`${END_POINT}/${countriesId}`);


export {
  getAllCountries,
  addCountry,
  getCountry,
  updateCountry,
  searchCountry,
  deleteCountry
};
